(function () {
  function safeParseJSON(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (e) {
      console.warn('Trusted Results Widget: invalid JSON', e);
      return null;
    }
  }

  function defaultCheckIcon() {
    return (
      '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">' +
        '<circle cx="12" cy="12" r="10" stroke="#19C37D" stroke-width="1.8"></circle>' +
        '<path d="M7 12.2L10.2 15.4L17.3 8.3" stroke="#19C37D" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +

        '<path d="M17.4 16.8H23.4" stroke="#FFFFFF" stroke-width="5.6" stroke-linecap="round"></path>' +
        '<path d="M20.4 13.8V19.8" stroke="#FFFFFF" stroke-width="5.6" stroke-linecap="round"></path>' +

        '<path d="M17.4 16.8H23.4" stroke="#19C37D" stroke-width="1.8" stroke-linecap="round"></path>' +
        '<path d="M20.4 13.8V19.8" stroke="#19C37D" stroke-width="1.8" stroke-linecap="round"></path>' +
      '</svg>'
    );
  }

  function TrustedResultsWidget(root) {
    this.root = root;
    this.widgetId = root.getAttribute('data-widget-id') || '';
    this.useVariantSwitch = root.getAttribute('data-use-variant-switch') === 'true';

    this.trigger = root.querySelector('[data-trw-trigger]');
    this.modalWrap = root.querySelector('[data-trw-modal-wrap]');
    this.modal = root.querySelector('[data-trw-modal]');
    this.closeButtons = root.querySelectorAll('[data-trw-close]');
    this.shareButton = root.querySelector('[data-trw-share]');
    this.groupSelect = root.querySelector('[data-trw-group-select]');
    this.tabsWrap = root.querySelector('[data-trw-tabs]');

    this.monthNode = root.querySelector('[data-trw-month]');
    this.summaryLineNode = root.querySelector('[data-trw-summary-line]');

    this.heroTitleNode = root.querySelector('[data-trw-hero-title]');
    this.heroCopyNode = root.querySelector('[data-trw-hero-copy]');
    this.summaryNode = root.querySelector('[data-trw-summary]');
    this.infoBoxNode = root.querySelector('[data-trw-info-box]');
    this.infoKickerNode = root.querySelector('[data-trw-info-kicker]');
    this.infoTextNode = root.querySelector('[data-trw-info-text]');
    this.infoIconNode = root.querySelector('[data-trw-info-icon]');
    this.resultIconNode = root.querySelector('[data-trw-result-icon]');
    this.resultLabelNode = root.querySelector('[data-trw-result-label]');
    this.resultValueNode = root.querySelector('[data-trw-result-value]');
    this.testedDateNode = root.querySelector('[data-trw-tested-date]');
    this.approvalLabelNode = root.querySelector('[data-trw-approval-label]');
    this.signatureNode = root.querySelector('[data-trw-signature]');
    this.approverNode = root.querySelector('[data-trw-approver]');
    this.accreditationTitleNode = root.querySelector('[data-trw-accreditation-title]');
    this.accreditationSubtitleNode = root.querySelector('[data-trw-accreditation-subtitle]');
    this.disclaimerNode = root.querySelector('[data-trw-disclaimer]');

    this.dataScript = root.querySelector('[data-trw-json]');
    this.data = safeParseJSON(this.dataScript ? this.dataScript.textContent : '') || {};
    this.groups = Array.isArray(this.data.groups) ? this.data.groups : [];

    this.activeGroupKey = '';
    this.activeTabKey = '';

    if (!this.groups.length) return;

    this.activeGroupKey = this.resolveInitialGroupKey();
    this.activeTabKey = this.resolveInitialTabKey(this.activeGroupKey);

    if (this.groups.length <= 1) {
      this.root.classList.add('trusted-results-widget--single-group');
    } else {
      this.root.classList.remove('trusted-results-widget--single-group');
    }

    this.bindEvents();
    this.render();
  }

  TrustedResultsWidget.prototype.bindEvents = function () {
    var self = this;

    if (this.trigger) {
      this.trigger.addEventListener('click', function () {
        self.open();
      });
    }

    if (this.modalWrap) {
      this.modalWrap.addEventListener('click', function (event) {
        var rect = self.modalWrap.getBoundingClientRect();
        var inside =
          event.clientX >= rect.left &&
          event.clientX <= rect.right &&
          event.clientY >= rect.top &&
          event.clientY <= rect.bottom;
        if (!inside) self.close();
      });

      this.modalWrap.addEventListener('close', function () {
        document.body.classList.remove('trusted-results-widget-lock');
        if (self.trigger) self.trigger.setAttribute('aria-expanded', 'false');
      });
    }

    this.closeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.close();
      });
    });

    if (this.shareButton) {
      this.shareButton.addEventListener('click', function () {
        var url = window.location.href;
        if (navigator.share) {
          navigator.share({
            title: document.title,
            url: url
          }).catch(function () {});
          return;
        }

        if (navigator.clipboard && window.isSecureContext) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    }

    if (this.groupSelect) {
      this.groupSelect.addEventListener('change', function (event) {
        self.setGroup(event.target.value);
      });
    }

    if (this.tabsWrap) {
      this.tabsWrap.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-trw-tab-key]');
        if (!btn) return;
        self.setTab(btn.getAttribute('data-trw-tab-key'));
      });
    }

    if (this.useVariantSwitch) {
      document.addEventListener('variant:change', function (event) {
        var variantId =
          event &&
          event.detail &&
          event.detail.variant &&
          event.detail.variant.id
            ? String(event.detail.variant.id)
            : '';

        if (variantId) {
          self.setGroupByVariantId(variantId);
        }
      });

      document.addEventListener('change', function (event) {
        var target = event.target;
        if (!target) return;

        if (
          target.matches('select[name="id"]') ||
          target.matches('input[name="id"]') ||
          target.matches('input[name="id"]:checked')
        ) {
          self.setGroupByVariantId(String(target.value || ''));
        }
      });
    }
  };

  TrustedResultsWidget.prototype.resolveInitialGroupKey = function () {
    var initialGroupKey = (this.data.initial_group_key || '').trim();
    var found = this.getGroupByKey(initialGroupKey);
    if (found) return found.key;

    if (this.useVariantSwitch) {
      var variantInput = document.querySelector('input[name="id"]:checked, select[name="id"], input[name="id"]');
      var variantId = variantInput ? String(variantInput.value || '') : '';
      if (variantId) {
        var matched = this.groups.find(function (group) {
          return group.variant_id && String(group.variant_id) === variantId;
        });
        if (matched) return matched.key;
      }
    }

    return this.groups[0].key;
  };

  TrustedResultsWidget.prototype.resolveInitialTabKey = function (groupKey) {
    var tabs = this.getTabsForGroup(groupKey);
    if (!tabs.length) return '';

    var defaultTab = tabs.find(function (tab) {
      return !!tab.default_active;
    });

    return defaultTab ? defaultTab.key : tabs[0].key;
  };

  TrustedResultsWidget.prototype.getGroupByKey = function (groupKey) {
    return this.groups.find(function (group) {
      return group.key === groupKey;
    });
  };

  TrustedResultsWidget.prototype.getTabsForGroup = function (groupKey) {
    var group = this.getGroupByKey(groupKey);
    return group && Array.isArray(group.tabs) ? group.tabs : [];
  };

  TrustedResultsWidget.prototype.getActiveGroup = function () {
    return this.getGroupByKey(this.activeGroupKey);
  };

  TrustedResultsWidget.prototype.getActiveTab = function () {
    var tabs = this.getTabsForGroup(this.activeGroupKey);
    return tabs.find(
      function (tab) {
        return tab.key === this.activeTabKey;
      }.bind(this)
    );
  };

  TrustedResultsWidget.prototype.setGroup = function (groupKey) {
    var group = this.getGroupByKey(groupKey);
    if (!group) return;

    this.activeGroupKey = group.key;

    var tabs = this.getTabsForGroup(group.key);
    var hasCurrent = tabs.some(
      function (tab) {
        return tab.key === this.activeTabKey;
      }.bind(this)
    );

    if (!hasCurrent) {
      this.activeTabKey = this.resolveInitialTabKey(group.key);
    }

    this.render();
  };

  TrustedResultsWidget.prototype.setTab = function (tabKey) {
    var tabs = this.getTabsForGroup(this.activeGroupKey);
    var found = tabs.find(function (tab) {
      return tab.key === tabKey;
    });

    if (!found) return;

    this.activeTabKey = found.key;
    this.renderTabs();
    this.renderCard();
  };

  TrustedResultsWidget.prototype.setGroupByVariantId = function (variantId) {
    if (!variantId) return;

    var matched = this.groups.find(function (group) {
      return group.variant_id && String(group.variant_id) === String(variantId);
    });

    if (!matched) return;
    if (matched.key === this.activeGroupKey) return;

    this.activeGroupKey = matched.key;
    this.activeTabKey = this.resolveInitialTabKey(matched.key);
    this.render();
  };

  TrustedResultsWidget.prototype.render = function () {
    this.renderTrigger();
    this.renderGroupSelect();
    this.renderTabs();
    this.renderCard();
  };

  TrustedResultsWidget.prototype.renderTrigger = function () {
    var group = this.getActiveGroup();
    if (!group) return;

    if (this.monthNode) {
      this.monthNode.textContent = group.badge_month || '';
    }

    if (this.summaryLineNode) {
      this.summaryLineNode.innerHTML = group.badge_summary || '';
    }
  };

  TrustedResultsWidget.prototype.renderGroupSelect = function () {
    if (!this.groupSelect) return;

    var html = this.groups.map(
      function (group) {
        var selected = group.key === this.activeGroupKey ? ' selected' : '';
        return '<option value="' + this.escapeAttr(group.key) + '"' + selected + '>' + this.escapeHtml(group.label || group.key) + '</option>';
      }.bind(this)
    ).join('');

    this.groupSelect.innerHTML = html;
  };

  TrustedResultsWidget.prototype.renderTabs = function () {
    if (!this.tabsWrap) return;

    var tabs = this.getTabsForGroup(this.activeGroupKey);

    this.tabsWrap.innerHTML = tabs.map(
      function (tab) {
        var isActive = tab.key === this.activeTabKey;
        return (
          '<button class="trusted-results-widget__tab' +
          (isActive ? ' is-active' : '') +
          '" type="button" data-trw-tab-key="' +
          this.escapeAttr(tab.key) +
          '">' +
          this.escapeHtml(tab.label || tab.key) +
          '</button>'
        );
      }.bind(this)
    ).join('');
  };

  TrustedResultsWidget.prototype.renderCard = function () {
    var group = this.getActiveGroup();
    var tab = this.getActiveTab();
    if (!group) return;

    if (this.heroTitleNode) {
      this.heroTitleNode.innerHTML = group.header_title || '';
    }

    if (this.heroCopyNode) {
      this.heroCopyNode.innerHTML = group.header_copy || '';
    }

    if (this.summaryNode) {
      this.summaryNode.innerHTML = tab ? (tab.summary || '') : '';
    }

    if (this.infoBoxNode) {
      var hasInfoKicker = !!(tab && tab.info_kicker);
      var hasInfoText = !!(tab && tab.info_text);
      var hasInfoIcon = !!(tab && tab.info_icon);
      var hasInfoBox = hasInfoKicker || hasInfoText || hasInfoIcon;

      if (hasInfoBox) {
        this.infoBoxNode.hidden = false;

        if (this.infoKickerNode) {
          this.infoKickerNode.innerHTML = hasInfoKicker ? tab.info_kicker : '';
          this.infoKickerNode.style.display = hasInfoKicker ? '' : 'none';
        }

        if (this.infoTextNode) {
          this.infoTextNode.innerHTML = hasInfoText ? tab.info_text : '';
          this.infoTextNode.style.display = hasInfoText ? '' : 'none';
        }

        if (this.infoIconNode) {
          if (hasInfoIcon) {
            this.infoIconNode.innerHTML = '<img src="' + this.escapeAttr(tab.info_icon) + '" alt="" loading="lazy">';
            this.infoIconNode.style.display = '';
          } else {
            this.infoIconNode.innerHTML = '';
            this.infoIconNode.style.display = 'none';
          }
        }
      } else {
        this.infoBoxNode.hidden = true;

        if (this.infoKickerNode) {
          this.infoKickerNode.innerHTML = '';
          this.infoKickerNode.style.display = 'none';
        }

        if (this.infoTextNode) {
          this.infoTextNode.innerHTML = '';
          this.infoTextNode.style.display = 'none';
        }

        if (this.infoIconNode) {
          this.infoIconNode.innerHTML = '';
          this.infoIconNode.style.display = 'none';
        }
      }
    }

    if (this.resultLabelNode) {
      this.resultLabelNode.innerHTML = tab ? (tab.result_label || '') : '';
    }

    if (this.resultValueNode) {
      this.resultValueNode.innerHTML = tab ? (tab.result_value || '') : '';
    }

    if (this.resultIconNode) {
      if (tab && tab.result_icon) {
        this.resultIconNode.innerHTML = '<img src="' + this.escapeAttr(tab.result_icon) + '" alt="" loading="lazy">';
      } else {
        this.resultIconNode.innerHTML = defaultCheckIcon();
      }
    }

    if (this.testedDateNode) {
      this.testedDateNode.innerHTML = (tab && tab.tested_date) || group.tested_date || '';
    }

    if (this.approvalLabelNode) {
      this.approvalLabelNode.innerHTML = group.approval_label || '';
    }

    if (this.signatureNode) {
      if (group.signature_image) {
        this.signatureNode.style.display = '';
        this.signatureNode.innerHTML = '<img src="' + this.escapeAttr(group.signature_image) + '" alt="" loading="lazy">';
      } else {
        this.signatureNode.style.display = 'none';
        this.signatureNode.innerHTML = '';
      }
    }

    if (this.approverNode) {
      var approverParts = [];
      if (group.approver_name) approverParts.push(group.approver_name);
      if (group.approver_title) approverParts.push(group.approver_title);
      this.approverNode.innerHTML = approverParts.join(', ');
    }

    if (this.accreditationTitleNode) {
      this.accreditationTitleNode.innerHTML = group.accreditation_title || '';
    }

    if (this.accreditationSubtitleNode) {
      this.accreditationSubtitleNode.innerHTML = group.accreditation_subtitle || '';
    }

    if (this.disclaimerNode) {
      this.disclaimerNode.innerHTML = group.disclaimer || '';
    }
  };

  TrustedResultsWidget.prototype.open = function () {
    var dialog = this.modalWrap;
    if (!dialog) return;

    if (dialog.parentNode !== document.body) {
      if (this.root.classList.contains('trusted-results-widget--single-group')) {
        dialog.classList.add('trusted-results-widget--single-group');
      }
      document.body.appendChild(dialog);
    }

    if (!dialog.open) dialog.showModal();
    if (this.trigger) this.trigger.setAttribute('aria-expanded', 'true');
    document.body.classList.add('trusted-results-widget-lock');
  };

  TrustedResultsWidget.prototype.close = function () {
    if (this.modalWrap && this.modalWrap.open) this.modalWrap.close();
  };

  TrustedResultsWidget.prototype.escapeHtml = function (value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  };

  TrustedResultsWidget.prototype.escapeAttr = function (value) {
    return this.escapeHtml(value);
  };

  function initTrustedResultsWidgets() {
    var widgets = document.querySelectorAll('[data-trusted-results-widget]');
    if (!widgets.length) return;

    widgets.forEach(function (root) {
      if (root.dataset.trwInitialized === 'true') return;
      var id = root.getAttribute('data-widget-id') || '';
      document.querySelectorAll('dialog.trusted-results-widget__modal-wrap[data-widget-id="' + id + '"]').forEach(function (dialog) {
        if (!root.contains(dialog)) dialog.remove();
      });
      root.dataset.trwInitialized = 'true';
      new TrustedResultsWidget(root);
    });
  }

  document.addEventListener('DOMContentLoaded', initTrustedResultsWidgets);
  document.addEventListener('shopify:section:load', initTrustedResultsWidgets);
})();